import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { _all_product } from "../common/axios_services";
import { notification, Skeleton } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../slices/cartSlice";
import NumberFormat from "react-number-format";
import { LoadingOutlined } from "@ant-design/icons/lib/icons";
import { ReactComponent as PlusIcon } from "../assets/images/icons/plus.svg";

const OtherProducts = () => {
  const [allProducts, setAllProducts] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [pageSize] = React.useState(24);
  const [page, setPage] = React.useState(1);
  const [total, setTotal] = React.useState(0);

  const dispatch = useDispatch();
  const [addToCartButton, setAddToCartButton] = useState(false);
  const local_cart = useSelector((state) => state.userCart?.cart);

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: "",
      description: message,
    });
  };

  const getAllProducts = async () => {
    setLoadingData(true);
    setAllProducts([]);
    try {
      const products = await _all_product({
        page: page,
        per_page: 5,
        search: "",
      });
      const list = Array.isArray(products?.data?.data)
        ? products.data.data
        : Array.isArray(products?.data)
          ? products.data
          : [];
      setAllProducts(list);
      setLoadingData(false);
      setTotal(products?.data?.meta?.total || list.length);
    } catch (err) {
      setAllProducts([]);
      setLoadingData(false);
    }
  };

  useEffect(() => {
    getAllProducts();
  }, []);

  let skeleton = [];
  for (let i = 0; i < 10; i++) {
    skeleton.push(
      <div key={i}>
        <Skeleton.Image style={{ width: "100%", height: "15rem" }} active />
        <Skeleton.Button style={{ marginTop: 10 }} active />
      </div>
    );
  }

  const shopBreakpoints = {
    0: { slidesPerView: 2.5 },
    600: { slidesPerView: 2.5 },
    1000: { slidesPerView: 1.5 },
  };

  const uploadToCart = ({ product }) => {
    setAddToCartButton(true);
    if (!local_cart) {
      let cart = {
        data: [],
        total_amount: 0,
        total_item: 0,
        total_weight: 0,
      };
      let new_cart = {
        id: product.id,
        name: product.name || product.product_name,
        product_image: product.product_image,
        price: product.konnect_price,
        market_price: product.market_price,
        public_price: product.public_price,
        discount: product.discount,
        weight: product.weight,
        available_quantity: product.available_quantity,
        description: product.description,
        state: product.state,
        sub_category_id: product.sub_category_id,
        lga: product.lga,
        sku: product.sku,
        status: product.status,
        cashback: product?.subcat?.cashback * product?.konnect_price * 0.01 || 0,
        subcat: product.subcat,
        quantity: 1,
      };
      cart.data.push(new_cart);
      cart.total_amount = cart.total_amount + (product.konnect_price || 0);
      cart.total_item = cart.data.length;
      cart.total_weight = cart.total_weight + (product.weight || 0);
      dispatch(addToCart(cart));
      setAddToCartButton(false);
      openNotificationWithIcon("success", "Product added to Cart Successfully");
      localStorage.setItem("konnect_cart", JSON.stringify(cart));
    } else {
      let newProd = { ...local_cart };
      const isProductInCart = newProd.data?.some(
        (cartItem) => cartItem.id === product.id
      );
      if (!isProductInCart) {
        let new_cart = {
          id: product.id,
          name: product.name || product.product_name,
          product_image: product.product_image,
          price: product.konnect_price,
          market_price: product.market_price,
          public_price: product.public_price,
          discount: product.discount,
          weight: product.weight,
          available_quantity: product.available_quantity,
          description: product.description,
          state: product.state,
          sub_category_id: product.sub_category_id,
          lga: product.lga,
          sku: product.sku,
          status: product.status,
          quantity: 1,
          cashback: product?.subcat?.cashback * product?.konnect_price * 0.01 || 0,
          subcat: product.subcat,
        };
        newProd.data = newProd.data || [];
        newProd.data.push(new_cart);
        newProd.total_amount = (newProd.total_amount || 0) + (product.konnect_price || 0);
        newProd.total_item = newProd.data.length;
        newProd.total_weight = (newProd.total_weight || 0) + (product.weight || 0);
        dispatch(addToCart(newProd));
        setAddToCartButton(false);
        openNotificationWithIcon("success", "Product added to Cart Successfully");
        localStorage.setItem("konnect_cart", JSON.stringify(newProd));
      } else {
        openNotificationWithIcon("success", "Product in cart already");
      }
      setAddToCartButton(false);
    }
  };

  return (
    <div>
      <div>
        <h3 className="tile-header">Trending Products</h3>
        <Swiper spaceBetween={15} breakpoints={shopBreakpoints}>
          {loadingData
            ? skeleton.map((s, index) => (
                <SwiperSlide key={index}>{s}</SwiperSlide>
              ))
            : (Array.isArray(allProducts) ? allProducts : []).map(
                (product, index) => (
                  <SwiperSlide key={index}>
                    <div className="product-data-cover">
                      <div className="product-img-header">
                        <img src={product?.product_image} alt="" />
                        {!addToCartButton ? (
                          <div
                            onClick={() => uploadToCart({ product: product })}
                            className="product-plus-icon"
                          >
                            <PlusIcon />
                          </div>
                        ) : (
                          <div className="product-plus-icon">
                            <LoadingOutlined style={{ fontSize: "20px" }} />
                          </div>
                        )}
                      </div>
                      <h5 className="product-title">{product?.product_name}</h5>
                      <h3 className="product-amount">
                        <span className="currency">NGN</span>
                        <NumberFormat
                          className="new_product_amount"
                          value={product.konnect_price}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                      <p className="product-desc">Free shipping</p>
                    </div>
                  </SwiperSlide>
                )
              )}
        </Swiper>
      </div>
    </div>
  );
};

export default OtherProducts;